import { type FC, useMemo } from 'react';

import { getStorages } from '../../../../ducks/storages/selectors';
import { useFetchMissingUploadStorageAcls } from '../../../../ducks/uploader/hooks/use_fetch_missing_upload_storage_acls';
import { selectWritableUploadStorages } from '../../../../panels/uploads/selectors';
import { useAppSelector } from '../../../../store/react_redux_typed';
import SelectFieldWrapper, {
  type SelectFieldWrapperProps,
} from '../select/select';

type Props = Omit<SelectFieldWrapperProps, 'isMulti'> & {
  isMulti: false;
};

export const SelectUploadStorageFieldWrapper: FC<Props> = (props) => {
  const storages = useAppSelector(getStorages);
  const writableCloudStorages = useAppSelector(selectWritableUploadStorages);

  const storageIds = useMemo(() => {
    return Object.values(storages).map(({ id }) => id);
  }, [storages]);

  useFetchMissingUploadStorageAcls(storageIds);

  const storageSelectOptions = Object.values(writableCloudStorages).map(
    ({ id, name }) => ({ value: id, label: name }),
  );

  return <SelectFieldWrapper {...props} options={storageSelectOptions} />;
};
